import React from 'react';
import PropTypes from 'prop-types';
import ConfirmationModal from './ConfirmationModal';
import i18n from '../../src/i18n/translate';
import { loadData } from '../util/ApiUtil';

const POLL_INTERVAL = 60000;
const TIMEOUT_WARNING_MS = 90000;
const SESSION_EXTENDING_EVENTS = ['load', 'mousemove', 'mousedown', 'click', 'scroll', 'keypress'];

export default class AutoLogout extends React.Component {
  static propTypes = {
    modalBody: PropTypes.node,
    modalTitle: PropTypes.string,
    redirectUrl: PropTypes.string
  };

  static defaultProps = {
    redirectUrl: ''
  };

  constructor(props) {
    super(props);

    this.state = {
      logout: false,
      warning: false
    };
  }

  componentDidMount() {
    this.checkAndUpdateSession();
    const pollSessionStatus = setInterval(() => {
      if (!this.state.logout) {
        this.checkAndUpdateSession();
      } else {
        clearInterval(pollSessionStatus);
        window.location.reload();
      }
    }, POLL_INTERVAL);
  }

  checkAndUpdateSession = async () => {
    const session = await this.getSessionStatus();
    
    this.setState({ 
      logout: !session.active,
      warning: session.active && session.seconds_until_expiration * 1000 <= TIMEOUT_WARNING_MS
    });
  }

  getSessionStatus = async () => {
    return await loadData('/session_status', {}, false, true);
  }

  addEventListeners = () => {
    SESSION_EXTENDING_EVENTS.map(event => {
      window.addEventListener(event, this.extendSession);
    });
  }

  removeEventListeners = () => {
    SESSION_EXTENDING_EVENTS.map(event => {
      window.removeEventListener(event, this.extendSession);
    });
  }

  onWarningAction = () => {
    this.addEventListeners();
    this.extendSession();
  }

  redirect = () => {
    if(this.props.redirectUrl){
      window.location.href = this.props.redirectUrl;
    } else {
      window.location.reload();
    }
  }

  extendSession = () => {
    this.setState({ warning: false }, () => {
      window.location.reload();
    });
  }

  get modalTitle() {
    return this.props.modalTitle || i18n.t("Your session has expired.");
  }

  get modalBody() {
    return this.props.modalBody || (
      <div>{i18n.t("Unfortunately, your session has expired and we require you to login again.")}</div>
    );
  }

  render() {
    return (
      <div>
        {this.state.logout && (
          <ConfirmationModal 
            title={this.modalTitle} 
            onConfirm={this.redirect} 
            canClose={false} 
            show={true} 
            confirmOnly={true} 
            children={this.modalBody}
          />
        )}
        {this.state.warning && (
          <ConfirmationModal 
            title={i18n.t('Your session is about to expire.')} 
            onConfirm={this.onWarningAction} 
            canClose={false} 
            show={true} 
            confirmOnly={true} 
            children={i18n.t('Would you like to stay logged in?')}
            confirmButtonText={i18n.t('Yes')}
          />
        )}
      </div>
    );
  }
}

